import { atom } from 'jotai';
import { User, Apartment, Info, View, Area } from '../CommonTypes';

export const isMobile = () => {
  return window.matchMedia('(max-width: 640px)').matches;
};

export const isIframe = () => {
  return window.self !== window.top;
};

// Atoms
export const showMapsViewAtom = atom<boolean>(false);
export const showSolarsViewAtom = atom<boolean>(false);
export const showPanoramaViewAtom = atom<boolean>(false);
export const showIframeViewAtom = atom<boolean>(false);
export const modalIsOpenAtom = atom(
  get => get(showMapsViewAtom) || get(showSolarsViewAtom) || get(showPanoramaViewAtom) || get(showIframeViewAtom)
);
export const showFirstTimePopupAtom = atom<boolean>(false);

export const infoTooltipOpenAtom = atom<boolean>(false);
export const overviewModalOpenAtom = atom<boolean>(false);
export const showFilterOptionsAtom = atom<boolean>(false);
export const showSolarOptionsAtom = atom<boolean>(false);
export const showCompassOptionsAtom = atom<boolean>(false);

export const viewlist = atom<View[]>([]);
export const currentSlideAtom = atom<number>(0);

export const userData = atom<User | null>(null);

export const hooveredApartmentId = atom<string | null>(null);
export const apartmentOnTopState = atom<Apartment | null>(null);
export const currentApartmentAtom = atom<Apartment | null>(null);

export const hoveredMapAreaAtom = atom<Area | null>(null);
export const hoveredViewAreaAtom = atom<Area | null>(null);
export const hoveredInfoAreaAtom = atom<Area | null>(null);
export const hoveredApartmentAreaAtom = atom<Area | null>(null);

export const apartmentsState = atom<Apartment[]>([]);

export const infoState = atom<Info[]>([]);

export const showAvailableState = atom<boolean>(false);

export const showROKState = atom<boolean[]>([true, true, true, true, true, true]);

export const apartmentFilter = atom(get => {
  const rokFilter = get(showROKState);
  const filter = (a: Apartment) => {
    if (a.rok == 1) return rokFilter[0];
    if (a.rok == 2) return rokFilter[1];
    if (a.rok == 3) return rokFilter[2];
    if (a.rok == 4) return rokFilter[3];
    if (a.rok == 5) return rokFilter[4];
    if (a.rok == 6) return rokFilter[5];
    return true;
  };
  return get(apartmentsState).filter(filter);
});

export const avalableROKInApartments = atom(get => {
  const apartments = get(apartmentsState);
  const availableROK = [0, 0, 0, 0, 0, 0] as number[];
  apartments.forEach(a => {
    if (a.rok == 1) availableROK[0]++;
    if (a.rok == 2) availableROK[1]++;
    if (a.rok == 3) availableROK[2]++;
    if (a.rok == 4) availableROK[3]++;
    if (a.rok == 5) availableROK[4]++;
    if (a.rok == 6) availableROK[5]++;
  });
  return availableROK;
});
